module.exports = __webpack_public_path__ + "img/kpmg.e9a9a757.svg";